/**
 * Given a number, round it to a maximum of `dec` decimal numbers.
 */
function roundNumber(num: number, dec: number) {
  return Math.round(num * 10 ** dec) / 10 ** dec;
}

export default roundNumber;
